import React from 'react';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import LoadingShimmer from 'Shared/components/LoadingShimmer/LoadingShimmer';

// Styles
import './IntegrationsLoading.scss';

type Props = {
  count?: number;
};
const IntegrationsLoading = ({ count = 4 }: Props) => {
  const baseClassName = 'IntegrationsLoading';

  const LoadingItem = () => {
    return (
      <WpContainer className={`${baseClassName} IntegrationsList__integration`}>
        <WpContainerBody>
          <div className={`${baseClassName}__header`}>
            <LoadingShimmer shape="square" width="40px" height="40px" />
            <LoadingShimmer shape="square" width="75px" height="28px" />
          </div>
          <div className={`${baseClassName}__title`}>
            <LoadingShimmer shape="square" width="150px" height="28px" />
          </div>
          <div className={`${baseClassName}__description`}>
            <LoadingShimmer shape="square" width="100%" height="16px" />
            <LoadingShimmer shape="square" width="45%" height="16px" />
          </div>
        </WpContainerBody>
      </WpContainer>
    );
  };

  return (
    <>
      {[...Array(count)].map((e, i) => (
        <LoadingItem key={i} />
      ))}
    </>
  );
};

export default IntegrationsLoading;
